import React from "react";
import "./App.css";
import Routes from "./Routes";

const App = () => {
  return <Routes />;
};

export default App;
